import { render, staticRenderFns } from "./xuqian.vue?vue&type=template&id=665b28c6&scoped=true&"
import script from "./xuqian.vue?vue&type=script&lang=js&"
export * from "./xuqian.vue?vue&type=script&lang=js&"
import style0 from "./xuqian.vue?vue&type=style&index=0&id=665b28c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b28c6",
  null
  
)

export default component.exports